import store from '../store/store'
import axios from '../axios'

export default class SettingService {

  // Pre loaded eps
  getPreLoadedEps() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/preLoadedData'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

//MBP
  getAllActiveBranchesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeMbpBranches'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activembpbranches`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllActiveBranches() {
    return new Promise(async function(resolve, reject) {
      
      if (store.getters[`commons/activembpbranches`]) {
        resolve(store.getters[`commons/activembpbranches`])
  
      } else {
        try {
          var path = '/v1/activeMbpBranches'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activembpbranches`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  getAllBranchesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/mbpBranches'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/mbpbranches`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllBranches() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/mbpbranches`]) {
        resolve(store.getters[`commons/mbpbranches`])
  
      } else {
        try {
          var path = '/v1/mbpBranches'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/mbpbranches`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

  updateBranch(id,branch) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/mbpBranch/'+id
        
        var response = await axios.put(path,branch)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveBranch(branch) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/mbpBranch/'
        
        var response = await axios.post(path,branch)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteBranch(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/mbpBranch/'+id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // MBP Departments
  getMBPDepts() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/mbpdepts'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // Regions
  getAllActiveRegionsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeRegions'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activeRegions`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActiveRegions() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeRegions'
        
        var response = await axios.get(path)
          // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllRegionsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/regions'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/regions`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllRegions() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/regions`]) {
        resolve(store.getters[`commons/regions`])
  
      } else {
        try {
          var path = '/v1/regions'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/regions`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }

}
